import { useEffect, useState } from 'react';
import axios from 'axios';

const useUserRoles = () => {
    const [roles, setRoles] = useState([]);
    const [isCommissioner, setIsCommissioner] = useState(false);
    const [isCaptain, setIsCaptain] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        axios.get('/api/users/current-user/', {
            withCredentials: true,
        })
            .then(response => {
                const { roles: roleNames = [], is_commissioner = false, is_captain = false } = response.data;
                setRoles(roleNames);
                setIsCommissioner(is_commissioner);
                setIsCaptain(is_captain);
                setLoading(false);
            })
            .catch(error => {
                console.error('Failed to fetch user roles', error);
                setError(error);
                setLoading(false);
            });
    }, []);

    return { roles, isCommissioner, isCaptain, loading, error };
};

export default useUserRoles;
